<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center no-scrollbar z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <div class="my-4">
            @for (item of options; track $index) {
            <div class="flex flex-row justify-start content-center">
                <input type="checkbox" (change)="onChangeOption($event)" [value]="item"
                    [checked]="selectedOption == item"
                    class="rounded my-auto outline-none ring-0 focus:outline-none focus:ring-0">
                <a (click)="onTextSelection(item)" class="cursor-pointer ml-2 capitalize">{{item}}</a>
            </div>
            }
        </div>
        <div class="flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()" class="btn-cancel">Cancel</button>
            <app-btn-action [label]="action" [isDisabled]="selectedOption == null" (clicked)="submit()"
                [inProgress]="(working$ | async) ?? false"
                bgColor="bg-primary-500 hover:bg-primary-700 disabled:bg-primary-200 active:bg-secondary-500">
            </app-btn-action>
        </div>
    </div>
</div>